import { Modal, ModalProps } from './Modal'
import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { Title3, BodyLarge } from '../styles/Typography'

interface ErrorModalProps extends ModalProps {
  title: string
  text: string
}

export const ErrorModal = ({ title, text, onClose }: ErrorModalProps) => {
  return (
    <Modal onClose={onClose}>
      <ErrorContainer>
        <Title3>{title}</Title3>
        <ErrorBodyLarge>{text}</ErrorBodyLarge>
      </ErrorContainer>
    </Modal>
  )
}

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 200px;
  justify-content: center;
  min-width: 300px;
  text-align: center;

  h3 {
    margin-top: ${theme.spacing.medium}px;
  }
`
const ErrorBodyLarge = styled(BodyLarge)`
  margin-bottom: ${theme.spacing.large}px;
`
